import * as React from "react";
import { asThemeConsumer } from "../../../theme/Theme";
import { joinClasses } from "../../../utils/Filters";
export var LinkTarget;
(function (LinkTarget) {
    LinkTarget["SELF"] = "_self";
    LinkTarget["BLANK"] = "_blank";
})(LinkTarget || (LinkTarget = {}));
export var isLinkPropsHref = function (p) { return !!p && p.hasOwnProperty("href"); };
export var isLinkPropsOnClick = function (p) { return !!p && p.hasOwnProperty("onClick"); };
/**
 *
 * @param props
 */
var LinkComp = function (props) {
    var _a;
    var clazzName = joinClasses("scl-a-link", props.className);
    return (isLinkPropsHref(props.link) && !props.disabled ?
        (React.createElement("a", { style: props.style, className: clazzName, href: props.link.href, download: props.link.download, target: props.link.target }, props.children))
        : (React.createElement("span", { style: props.style, className: clazzName, onClick: !isLinkPropsHref(props.link) && !props.disabled
                ? (_a = props === null || props === void 0 ? void 0 : props.link) === null || _a === void 0 ? void 0 : _a.onClick : undefined }, props.children)));
};
/**
 *
 */
export var Link = asThemeConsumer(LinkComp);
